import { CalenderReportType } from "src/app/enum/calender-report-type";

export class CalenderReportRequest {
  public constructor(
  ) {
  }
  
  public drugName?: string;
  public drugNameMessage?: string;
  public drugId?: string;

  public drugGroupNameMessage?: string;
  public drugGroupId: string="-1";
  
  public reportType: number =-1;
  public reportTypeMessage?: string;

  public insuranceId?: string;
  public insuranceMessage?: string;
}
